import React from "react"
import clsx from "clsx"

import {
  Asset,
  Breadcrumb,
  Button,
  Decorator,
  IconButton,
  RichText,
} from "components"

function Actions({ category, subcategory, className }) {
  return (
    <div className={clsx("space-y-8", className)}>
      <div className="text-center lg:text-left">
        <Button
          label="Become a customer"
          href="/become-a-customer/"
          appearance="primary"
          size="large"
        />
      </div>
      <ul className="space-y-6">
        {subcategory.products && subcategory.products[0] && (
          <li>
            <IconButton
              label="Varieties"
              href="#varieties"
              icon="arrow-down"
              animate="down"
            />
          </li>
        )}
        <li>
          <IconButton
            label="Details"
            href="#details"
            icon="arrow-down"
            animate="down"
          />
        </li>
        {category.faqItems && category.faqItems[0] && (
          <li>
            <IconButton
              label="FAQ"
              href="#faq"
              icon="arrow-down"
              animate="down"
            />
          </li>
        )}
      </ul>
    </div>
  )
}

function Hero({ category, subcategory }) {
  return (
    <header className="pb-8 overflow-hidden md:overflow-visible wrapper default-grid gap-y-14 lg:pb-24">
      <div className="pt-8 space-y-4 col-span-full lg:col-span-6 lg:pt-24">
        <Breadcrumb
          label={category.name}
          href={`/products/${category.slug}/`}
        />
        <div className="space-y-8">
          <div className="space-y-6">
            <h1 className="h2 text-darkNavy">{subcategory.title}</h1>
            <RichText content={subcategory.description} size="large" />
          </div>
          <Actions
            className="hidden lg:block"
            category={category}
            subcategory={subcategory}
          />
        </div>
      </div>
      <div className="col-span-full lg:col-span-3 lg:col-start-10 lg:pt-40">
        <div className="px-7 md:px-0 lg:-mr-fluidMargin xl:-mr-26">
          <div className="aspect-w-1 aspect-h-1">
            {subcategory.photo && (
              <Asset
                asset={subcategory.photo}
                objectFit="cover"
                objectPosition="center"
                style={{ position: "absolute" }}
              />
            )}
            <div>
              {subcategory.decorators && subcategory.decorators[0] && (
                <Decorator
                  className="absolute left-0 translate-y-1/2 select-none -translate-x-7 md:-translate-x-1/2 bottom-4 md:left-4"
                  asset={
                    subcategory.decorators && subcategory.decorators[0].asset
                  }
                  size="small"
                />
              )}
              {subcategory.decorators && subcategory.decorators[1] && (
                <Decorator
                  className="absolute translate-x-1/2 -translate-y-1/2 top-6 right-6"
                  asset={
                    subcategory.decorators && subcategory.decorators[1].asset
                  }
                  size="small"
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <Actions
        className="block pt-8 col-span-full lg:hidden"
        category={category}
        subcategory={subcategory}
      />
    </header>
  )
}

export default Hero
